module.exports = __webpack_public_path__ + "img/phone-32-red.1cd2dfee.svg";